import { IconButton, OpenInNew, Stack, Tooltip, Typography } from '@cmg/design-system';
import React from 'react';

import TextHighlighter from '../../../../../common/components/typography/text-highligher/TextHighlighter';
import routeFactory from '../../../../../common/util/routeFactory';
import { CompanyOption } from './types';

export type Props = {
  option: CompanyOption;
  searchInput: string;
};

export const CompanySearchOption: React.FC<Props> = ({ option, searchInput }) => {
  const handleNewTabClick = React.useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      window.open(routeFactory.companies.getUrlPath({ id: option.value }), '_blank');
    },
    [option.value]
  );

  const snippet = option.snippet?.replace(/<\/?em>/g, '') ?? '';
  const searchWords = searchInput.split(' ');

  return (
    <div key={option.value} style={{ width: '100%', display: 'flex' }}>
      {/* Left Side */}
      <Stack flex={1}>
        {/* Issuer Text Line */}
        <Stack flex={1}>
          <Stack direction="row" spacing={1} alignItems="center" flexBasis="100%">
            <Typography color="text.secondary" variant="button">
              {option.ticker}
            </Typography>
            <Typography variant="button">
              <TextHighlighter text={option.label} search={searchWords} />
            </Typography>
          </Stack>
        </Stack>
        {/* Issuer Snippet Line */}
        <div style={{ marginTop: 2 }}>
          <Typography variant="caption" color="text.secondary">
            <TextHighlighter text={snippet} search={searchWords} />
          </Typography>
        </div>
      </Stack>

      {/* Right Side */}
      {/* New Tab CTA */}
      <div>
        <IconButton onClick={handleNewTabClick}>
          <Tooltip title="Opens in a new tab">
            <OpenInNew fontSize="small" />
          </Tooltip>
        </IconButton>
      </div>
    </div>
  );
};

export default CompanySearchOption;
